import React from 'react';
import { render } from 'react-dom';

import createApp from './app';
import config from './config';

const QUICK_SKELETON_UI_DISMISS_MS = 100;
const SLOW_SKELETON_UI_DISMISS_MS = 500;

function onInit () {
    let stores = {};
    var storesContext = require.context("./stores", true, /\.js$/);
    storesContext.keys().forEach((file, ...args) => {
        // Load store module
        const module = storesContext(file, ...args);
        const [, storeName] = file.match(/\/(.*)\.js$/);
        stores[storeName] = module.default;
    });

    if (config.get('debug')) {
        // Expose stores & config globally
        Object.assign(window.OTRL, {stores, config});
    }
}

const dismissSkeletonUI = () => {
    const now = new Date();
    let skeleontUITimeout = QUICK_SKELETON_UI_DISMISS_MS;
    if (window.otrlWidgetStartDate) {
        const widgetLoadTimeMs = (now.getTime() - window.otrlWidgetStartDate.getTime());
        if (widgetLoadTimeMs > 2000) {
            // If it took longer to load the widget postpone hiding the skeleton UI
            // so React has enough time to render the widget first so the skeleton UI
            // is transitioning to already rendered widget and not an empty canvas.
            //
            // For most cases this will happen on a slow network connection
            // or for first-time users.
            skeleontUITimeout = SLOW_SKELETON_UI_DISMISS_MS;
        }
    }
    setTimeout(() => document.querySelector('.skeleton').classList.add('skeleton--hide'), skeleontUITimeout);
};

function onRender (containerEl) {
    const renderApp = () => {
        const Root = require('./components/Root').default;
        dismissSkeletonUI();
        render(<Root />, containerEl);
    };

    if (module.hot) {
        module.hot.accept('./components/Root.js', renderApp);
    }
    renderApp();
}


const app = window.OTRL = createApp(onInit, onRender);
export default app;
